import { JConfirmationBarContext } from '@/contexts/JConfirmationBarContext';
import { useContext } from 'react';

const useJConfirmationBar = () => {
  const context = useContext(JConfirmationBarContext);
  if (!context) {
    throw new Error(
      'useJConfirmationBar must be used within a JConfirmationBarProvider',
    );
  }
  return context;
};

export default useJConfirmationBar;
